import type { SyncState } from "../settings/sync";
import type { FormSaveState } from "./useFormSaving";

/**
 * UN SEUL ÉTAT POUR LE BADGE, à partir des deux enregistrements (réglages et
 * formulaires) et du compte des brouillons en attente.
 *
 * L'ordre est celui de l'urgence : un refus ou un échec passe devant tout, un envoi en
 * cours devant une attente, et « Enregistré » ne se dit que si plus rien n'attend et
 * qu'au moins un des deux a réellement envoyé quelque chose.
 */
export function combineSaveState(
  settings: SyncState,
  forms: FormSaveState,
  pendingForms: number,
): SyncState {
  if (settings === "refused") return "refused";
  if (settings === "failed" || forms === "failed") return "failed";
  if (settings === "saving" || forms === "saving") return "saving";
  if (settings === "waiting" || pendingForms > 0) return "waiting";
  if (settings === "saved" || forms === "saved") return "saved";
  return "idle";
}
